import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-1 max-w-7xl" }

import {
  computed,
  ref,
  watch,
} from 'vue';
import MemberMenu from '@/components/NavBar/MemberMenu.vue';
import PublicHeader from '@/components/NavBar/PublicHeader.vue';
import {
  useStore,
} from '@/store';

// const navStore = useStore.nav;

// const toggleLight = ref(false);

// watch(() => toggleLight.value, () => {
//   navStore.toggleTheme();
// });


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonHeader',
  setup(__props) {

const authStore = useStore.auth;

const user = computed(() => authStore.user);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (user.value)
      ? (_openBlock(), _createBlock(MemberMenu, { key: 0 }))
      : (_openBlock(), _createBlock(PublicHeader, { key: 1 }))
  ]))
}
}

})